export default __webpack_public_path__ + "static/media/feebback-icon.b4ba1c48.png";